import React, { useState, useEffect } from 'react';
import { Typography, TextField, Box, Popover, IconButton } from '@mui/material';

export default function EditableText({ value, displayValue, onSave, variant = 'body1', type = 'text', ...props }) {
  const [anchorEl, setAnchorEl] = useState(null);
  const [input, setInput] = useState(value);

  useEffect(() => {
    setInput(value);
  }, [value]);

  const handleOpen = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const handleSave = () => {
    if (input !== value) {
      onSave(input);
    }
    handleClose();
  };

  const open = Boolean(anchorEl);

  return (
    <Box sx={{ display: 'inline-block' }}>
      <Typography
        {...props}
        variant={variant}
        onClick={handleOpen}
        sx={{ cursor: 'pointer', display: 'inline' }}
      >
        {displayValue ?? value}
      </Typography>

      <Popover
        open={open}
        anchorEl={anchorEl}
        onClose={handleClose}
        anchorOrigin={{
          vertical: 'top',
          horizontal: 'left',
        }}
        transformOrigin={{
          vertical: 'bottom',
          horizontal: 'left',
        }}
        sx={{ pointerEvents: 'auto' }}
      >
        <Box sx={{ p: 2, minWidth: 280 }}>
          <TextField
            type={type}
            size="small"
            variant="standard"
            value={input}
            onChange={(e) => setInput(e.target.value)}
            onKeyDown={(e) => {
              if (e.key === 'Enter') handleSave();
              if (e.key === 'Escape') handleClose();
            }}
            autoFocus
            InputProps={{
              disableUnderline: true,
              style: {
                textAlign: props.align || 'left',
                fontWeight: props.fontWeight,
                fontSize: '1rem',
              }
            }}
            sx={{
              width: '100%',
              minWidth: 260,
              fontSize: '1.1rem',
              border: 'none',
              outline: 'none',
              backgroundColor: 'transparent',
            }}
          />
        </Box>
      </Popover>
    </Box>
  );
}